import React from "react"

interface Props {
    handleConfirm: () => void
}

export default function ModalDeleteWorkingHours(props: Props) {
    const MODAL_TITLE = "Êtes-vous sûr de vouloir supprimer cette configuration"
    const MODAL_DESCRIPTION = "Cette configuration d'horaire d'ouverture sera définitivement supprimé"

    return (
        <div id="modalDeleteWorkingHours" className="modal fade" tabIndex={-1} role="dialog" data-backdrop="static" data-keyboard="false">
            <div className="modal-dialog modal-dialog-centered modal-xl">
                <div className="modal-content border-0">
                    <div className="modal-header p-2 bg-light">
                        <span className="tw-text-xl tw-font-semibold">{MODAL_TITLE}</span>
                    </div>

                    <div className="modal-body">
                        <span className="tw-text-sm tw-text-slate-500">{MODAL_DESCRIPTION}</span>
                    </div>

                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-dismiss="modal">
                            Fermer
                        </button>

                        <button type="button" onClick={props.handleConfirm} className="btn btn-danger">
                            Supprimer
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
